import { Box, Button } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'

const NavigationButtons = ({
  activeStep,
  totalSteps,
  onBack,
  onNext,
  isNextDisabled = false,
  showSkipButton = false
}) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.navigationButtons} ${showSkipButton ? classes.navigationButtonsWithSkip : classes.navigationButtonsWithoutSkip}`} data-test='navigation-buttons'>
      <Button
        className={classes.backButton}
        onClick={onBack}
        disabled={activeStep === 0}
        data-test='navigation-back-button'
        aria-label={activeStep === 0 ? 'Back button disabled' : 'Go to previous step'}
      >
        ‹ Back
      </Button>

      <Button
        className={classes.nextButton}
        onClick={onNext}
        disabled={isNextDisabled}
        data-test='navigation-next-button'
        aria-label={activeStep === totalSteps - 1 ? 'Finish questionnaire' : 'Go to next step'}
      >
        {activeStep === totalSteps - 1 ? 'Finish' : 'Next ›'}
      </Button>
    </Box>
  )
}

export default NavigationButtons
